import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import ICoverageArea, { ICoverageAreaInput } from "@/interfaces/coverage-area.interface";
import coverageAreaService from "@/services/coverage-area.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateCoverageAreaProps = {
  formData: ICoverageAreaInput;
} & RequestsProps;

export type Return = {
  create: (props: CreateCoverageAreaProps) => Promise<ICoverageArea>;
} & UseLoadingReturn;

const useCreateCoverageArea = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } =
    useCreate<ICoverageAreaInput>({
      operation: (formData) => coverageAreaService.create(formData),
    });

  return { isLoading, startLoading, endLoading, loadingIcon, create };
};

export default useCreateCoverageArea;
